import { formatDate as _formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { createHttpOptions } from '../utils/http-utils';
import { FormatPriceUtils } from '../utils/format-price-utils';
import { ReportsPaginationFilters } from '../stores/reports.store';
import { RequestsPaginationFilters } from '../stores/requests.store';

export interface ExportRequestBody {
  pageIndex?: number;
  pageSize?: number;
  orderBy?: string;
  orderByDescending?: boolean;
  dateStart?: string;
  dateEnd?: string;
  amountMoreThan?: number;
  amountLessThan?: number;
  email?: string;
  receiverAddress?: string;
  blockchainTransactionId?: string;
  blockchainAssets?: string[];
  direction?: string;
  shortId?: string;
  blockchainCheckStatus?: string[];
  cryptoConnectionCheckStatus?: string[];
  exchangeConversionRequestStatus?: string[];
  offRampStatus?: string[];
}

export type ExportType = 'PaymentReport' | 'PaymentRequest';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  private http = inject(HttpClient);
  protected formatPrice = inject(FormatPriceUtils);

  getAllPaymentReports(filters: ReportsPaginationFilters): Observable<any> {
    const body = filters;

    return this.http.post(environment.api + 'PaymentReport/all', body, createHttpOptions());
  }

  getAllPaymentRequests(filters: RequestsPaginationFilters): Observable<any> {
    const body = filters;

    return this.http.post(environment.api + 'PaymentRequest/all', body, createHttpOptions());
  }

  exportData(type: ExportType, customBody?: Partial<ExportRequestBody>) {
    const defaultBody: ExportRequestBody = {
      ...customBody,
    };

    const body = { ...defaultBody, ...customBody };
    const endpoint = `${environment.api}${type}/export`;

    return this.http
      .post(endpoint, body, {
        ...createHttpOptions(),
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        tap((response) => {
          const blob = new Blob([response.body!], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          const filename = `${type.toLowerCase()}-export.csv`;

          link.href = url;
          link.download = filename;
          link.click();

          window.URL.revokeObjectURL(url);
        }),
      );
  }

  exportReport(customBody?: Partial<ExportRequestBody>) {
    return this.exportData('PaymentReport', customBody);
  }

  exportPaymentRequest(customBody?: Partial<ExportRequestBody>) {
    return this.exportData('PaymentRequest', customBody);
  }
}
